import { getDashboards } from '../services/dashboardService'
import DashboardCard from '../components/DashboardCard'

export default function Home() {
  const dashboards = getDashboards()

  return (
    <div className="relative min-h-full">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 right-0 h-72 w-72 rounded-full bg-cbc-primary/10 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-80 w-80 rounded-full bg-cbc-medium-blue/10 blur-3xl" />
      </div>
      {/* Hero banner */}
      <div className="relative bg-gradient-to-r from-cbc-navy via-cbc-dark-blue to-cbc-dark-blue px-4 md:px-8 py-6 md:py-10 overflow-hidden border-b border-cbc-medium-blue/15">
        <div className="absolute right-0 top-0 h-full w-2/5 bg-gradient-to-l from-cbc-primary/10 to-transparent pointer-events-none" />
        <div className="absolute right-16 top-1/2 -translate-y-1/2 w-32 h-32 bg-cbc-primary/10 rounded-full blur-3xl pointer-events-none" />
        {/* Accent line */}
        <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-cbc-primary to-transparent opacity-60" />
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex items-center space-x-3 mb-2">
            <div className="w-1 h-7 bg-gradient-to-b from-cbc-primary to-cbc-medium-blue rounded-full" />
            <h1 className="text-xl font-bold text-white tracking-tight">
              Dashboards de Control de Gestión
            </h1>
          </div>
          <p className="text-sm text-cbc-light-blue/75 ml-4">
            Análisis financiero corporativo · Corporación de Bienes de Capital
          </p>
        </div>
      </div>

      {/* Cards grid */}
      <div className="relative z-10 p-4 md:p-8 max-w-7xl mx-auto">
        {dashboards.length === 0 ? (
          <div className="rounded-2xl border border-cbc-medium-blue/20 bg-cbc-dark-blue/40 backdrop-blur-xl shadow-cbc-dark p-12 text-center animate-fadeIn">
            <svg className="w-14 h-14 text-cbc-medium-blue/55 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
            </svg>
            <h3 className="text-base font-semibold text-cbc-paper mb-1">No hay dashboards disponibles</h3>
            <p className="text-sm text-cbc-light-blue/70">Contacta al administrador para obtener acceso.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {dashboards.map((dashboard, index) => (
              <div
                key={dashboard.id}
                className="animate-fadeIn"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <DashboardCard dashboard={dashboard} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
